import React from "react";
import { HydrateUtils } from "../../utils/hydrate";
import { MainPageContent } from "../../components/mainPageContent";

interface IMainPageData {}
HydrateUtils.hydratePage<IMainPageData>((data) => <MainPageContent />);
